import { render } from "./SearchMember2.vue?vue&type=template&id=0f45227b"
import script from "./SearchMember2.vue?vue&type=script&lang=js"
export * from "./SearchMember2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/user/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.12_vue@3.5.12_typescript@5.6.3__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__